
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/poweron-pro",
      function () {
        return require("private-next-pages/legal/poweron-pro/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/poweron-pro"])
      });
    }
  